function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.449 6.526l.808 10.116 5.802 7.516-.567.621-7.646-7.257.802-10.996h.801z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.56 1C7.48 1.233 1 7.858 1 15.997 1 24.283 7.716 31 16 31c8.284 0 15-6.717 15-15.003 0-3.023-.894-5.837-2.432-8.193l-1.58 1.204a12.965 12.965 0 012.033 6.989c0 7.192-5.83 13.023-13.021 13.023-7.191 0-13.02-5.83-13.02-13.023 0-7.045 5.593-12.784 12.58-13.016V1z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.335 1.984a3.996 3.996 0 11-5.4 5.402 3.996 3.996 0 005.4-5.402z",
  fill: "currentColor"
})));